/**
 * Autoplay-reparatie voor losse video's, buiten de hero.
 *
 * Zelfde drie stappen als in hero.js: direct proberen, opnieuw zodra het
 * tabblad zichtbaar wordt, en bij het eerste gebaar van de bezoeker. Die
 * laatste is de betrouwbaarste, want na een gebruikersgebaar staat elke
 * browser afspelen toe. Lukt het niet, dan blijft de poster staan.
 *
 * Aanvullend hierop: pas afspelen zodra de video in beeld komt, en pauzeren
 * als hij eruit gaat. Een sfeervideo halverwege de pagina hoeft niet te lopen
 * terwijl niemand ernaar kijkt.
 */
const videos = document.querySelectorAll("video[data-autoplay]");

if (videos.length) {
  const gestures = ["touchstart", "pointerdown", "keydown", "scroll"];
  const wanted = new Set();

  const attempt = () => {
    for (const video of wanted) {
      video.play().catch(() => {});
    }
  };

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          wanted.add(entry.target);
          entry.target.play().catch(() => {});
        } else {
          wanted.delete(entry.target);
          entry.target.pause();
        }
      }
    },
    { rootMargin: "100px" },
  );

  for (const video of videos) {
    video.muted = true;
    video.defaultMuted = true;
    observer.observe(video);
  }

  document.addEventListener("visibilitychange", attempt);
  gestures.forEach((type) => window.addEventListener(type, attempt, { passive: true }));
}
